// This file is auto-generated. Do not edit!
export default [
  {
    chain: "eth",
    description: "Ethereum",
    domain: "0",
  },
  {
    chain: "oeth",
    description: "Optimism",
    domain: "2",
  },
  {
    chain: "arb1",
    description: "Arbitrum",
    domain: "3",
  },
  {
    chain: "base",
    description: "Base",
    domain: "6",
  },
] as const
